module.exports = __webpack_public_path__ + "img/60.c80dcd28.png";